import { useGetTkbStatsQuery } from 'mmfintech-backend-api'
import { formatFloat, tr } from 'mmfintech-commons'

import './tkbUsageBar.scss'

const TKB_SYMBOL = 'TKB'
const TKB_DECIMALS = 2

export const TkbUsageBar = () => {
  const { data: stats } = useGetTkbStatsQuery()

  const { monthlyUsedTkb = 0, monthlyLimitTkb = 0 } = stats || {}

  // Hide the bar until we have a configured monthly TKB limit to measure against.
  if (!stats || !monthlyLimitTkb) {
    return null
  }

  const progressPercentage = Math.min(100, (monthlyUsedTkb / monthlyLimitTkb) * 100)
  const limitReached = monthlyUsedTkb >= monthlyLimitTkb

  return (
    <div className='tkb-usage-bar-wrapper' data-test='tkb-usage-bar'>
      <div className='tkb-usage-bar-header'>
        <span className='tkb-usage-amount'>
          <span className='used'>
            {formatFloat(monthlyUsedTkb, TKB_DECIMALS)} <span className='unit'>{TKB_SYMBOL}</span>
          </span>{' '}
          <span className='limit'>
            {tr('FRONTEND.DASHBOARD.TKB_USAGE.OF', 'of')} {formatFloat(monthlyLimitTkb, TKB_DECIMALS)}{' '}
            <span className='unit'>{TKB_SYMBOL}</span>
          </span>
        </span>
        <span className='tkb-usage-period'>{tr('FRONTEND.DASHBOARD.PERIOD_MONTH', 'This Month')}</span>
      </div>

      <div className='tkb-usage-progress-track'>
        {progressPercentage > 0 && (
          <div className='tkb-usage-progress-fill' style={{ width: `${progressPercentage}%` }} />
        )}
      </div>

      <div className='tkb-usage-caption'>
        {limitReached
          ? tr('FRONTEND.DASHBOARD.TKB_USAGE.LIMIT_REACHED', "You've reached your monthly commitment.")
          : tr('FRONTEND.DASHBOARD.TKB_USAGE.CAPTION', 'TKB token earned this month')}
      </div>
    </div>
  )
}
